export class GlobalPair {
  idGlobalPair: number;
  idCurrency: number;
  idGlobalCurrency: number;
  showOnMainPage: boolean;
  useInQuantfury: boolean;
  locked: boolean;
  offset: number;

  constructor(
    idGlobalPair: number,
    idCurrency: number,
    idGlobalCurrency: number,
    showOnMainPage: boolean,
    useInQuantfury: boolean,
    locked: boolean,
    offset: number,
  ) {
    this.idGlobalPair = idGlobalPair;
    this.idCurrency = idCurrency;
    this.idGlobalCurrency = idGlobalCurrency;
    this.showOnMainPage = showOnMainPage;
    this.useInQuantfury = useInQuantfury;
    this.locked = locked;
    this.offset = offset;
  }

  static fromRaw(raw: any): GlobalPair {
    return new GlobalPair(
      raw.idGlobalPair,
      raw.idCurrency,
      raw.idGlobalCurrency,
      Boolean(raw.showOnMainPage),
      Boolean(raw.useInQuantfury),
      Boolean(raw.locked),
      Number(raw.offset),
    );
  }

  clone(): GlobalPair {
    return new GlobalPair(
      this.idGlobalPair,
      this.idCurrency,
      this.idGlobalCurrency,
      this.showOnMainPage,
      this.useInQuantfury,
      this.locked,
      this.offset,
    );
  }

  toPayload(): any {
    return {
      idGlobalPair: this.idGlobalPair,
      idCurrency: this.idCurrency,
      idGlobalCurrency: this.idGlobalCurrency,
      showOnMainPage: this.showOnMainPage,
      useInQuantfury: this.useInQuantfury,
      locked: this.locked,
      offset: this.offset,
    };
  }
}
